<template>
  <li>
    <div class="worker_name">
      {{ `${item.first_name} ${item.surname} - ${item.job_title}` }}
    </div>
    <div class="status">
      <div
          v-if="item.submitted"
          class="submitted"
      >
        Completed
      </div>
    </div>
    <div class="buttons">
      <router-link
          :to="{ name: prefix + '_timesheet_edit_worker', params: { period, order_id, order_job_id: item.order_job_id, timesheet_id: item.timesheet_id } }">
        <button
            v-if="item.submitted"
            class="btn orcaBtn">
          View
        </button>
        <button
            v-else
            class="btn orcaBtn">
          Edit
        </button>
      </router-link>
    </div>
  </li>
</template>
<style scoped>
li {
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr;
  align-content: center;
  justify-content: flex-start;
  margin-bottom: 1em;
  padding: 0.5em;
  border-bottom: thin solid #eee;
}

li > .status, ul.worker-list > li > .buttons {
  display: grid;
  align-content: center;
  justify-content: flex-end;
}
</style>
<script>
export default {
  props: {
    prefix: {required: true},
    order_id: {required: true},
    period: {required: true},
    item: {type: Object, required: true},
  }
};
</script>